module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/en_okinawa-c5df26d575327da22286aa52305326c4.jpg";